module.exports = __webpack_public_path__ + "media/images/ceremony/plans/3/hall-list/plan-ceremony-lineup-tokai-2-9e6e1abd05a41f149a68b5a67d9f2199.png";